export default "__VITE_ASSET__BBtEj42u__"